import React from 'react';
import { CheckCircle, XCircle, Clock } from 'lucide-react';
import { Card } from '../../SubscriptionAppCard';
interface RetryAttempt {
  id: string;
  attemptNumber: number;
  date: string;
  time: string;
  status: 'success' | 'failed' | 'pending';
  reason?: string;
  amount: string;
}
interface PaymentRetryHistoryProps {
  retryAttempts: RetryAttempt[];
}
export function PaymentRetryHistory({
  retryAttempts
}: PaymentRetryHistoryProps) {
  if (!retryAttempts || retryAttempts.length === 0) {
    return null;
  }
  const getStatusIcon = (status: 'success' | 'failed' | 'pending') => {
    switch (status) {
      case 'success':
        return <CheckCircle className="w-5 h-5 text-[#10B981]" data-id="element-3033" />;
      case 'failed':
        return <XCircle className="w-5 h-5 text-[#EF4444]" data-id="element-3034" />;
      case 'pending':
        return <Clock className="w-5 h-5 text-[#64748B]" data-id="element-3035" />;
    }
  };
  const getStatusText = (attempt: RetryAttempt) => {
    if (attempt.status === 'success') {
      return <span className="text-[13px] text-[#10B981]" data-id="element-3036">Success</span>;
    }
    if (attempt.status === 'pending') {
      return <span className="text-[13px] text-[#64748B]" data-id="element-3037">Pending</span>;
    }
    if (attempt.status === 'failed' && attempt.reason) {
      return <span className="text-[13px] text-[#EF4444]" data-id="element-3038">
          Failed - {attempt.reason}
        </span>;
    }
    return <span className="text-[13px] text-[#EF4444]" data-id="element-3039">Failed</span>;
  };
  return <Card padding="none" data-id="element-3040">
      <div className="p-6 border-b border-[#E2E8F0] bg-gradient-to-r from-[#F8FAFC] to-white" data-id="element-3041">
        <h3 className="text-[20px] font-semibold text-[#0F172A]" data-id="element-3042">
          Payment Retry History
        </h3>
      </div>

      <div className="p-6 bg-white" data-id="element-3043">
        <div className="space-y-4" data-id="element-3044">
          {retryAttempts.map((attempt, index) => <div key={attempt.id} className="relative" data-id="element-3045">
              {/* Connector line */}
              {index < retryAttempts.length - 1 && <div className="absolute left-[10px] top-[28px] bottom-[-16px] w-[2px] bg-[#E2E8F0]" data-id="element-3046" />}

              {/* Timeline item */}
              <div className="flex items-start gap-4" data-id="element-3047">
                {/* Status icon */}
                <div className="flex-shrink-0 relative z-10 bg-white" data-id="element-3048">
                  {getStatusIcon(attempt.status)}
                </div>

                {/* Details */}
                <div className="flex-1 min-w-0" data-id="element-3049">
                  <div className="flex items-baseline justify-between gap-4" data-id="element-3050">
                    <div data-id="element-3051">
                      <div className="text-[14px] font-medium text-[#0F172A]" data-id="element-3052">
                        {attempt.attemptNumber === 0 ? 'Initial Payment' : `Retry ${attempt.attemptNumber}`}
                        {attempt.status === 'pending' && ' (Scheduled)'}
                      </div>
                      <div className="text-[13px] text-[#64748B] mt-0.5" data-id="element-3053">
                        {attempt.date} at {attempt.time}
                      </div>
                      <div className="mt-1" data-id="element-3054">{getStatusText(attempt)}</div>
                    </div>

                    {/* Amount */}
                    {attempt.amount && attempt.status !== 'pending' && <div className="text-[14px] font-medium text-[#0F172A] flex-shrink-0" data-id="element-3055">
                        {attempt.amount}
                      </div>}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </Card>;
}